<template>
  <div class="mt-12px">
    <div class="half-graph-container">
      <div
        class="
          d-flex
          justify-content-between
          align-items-center
          border-bottom
          px-2
          pb-2
        "
      >
        <div class="dashboardAdmin-cards-head ml-2">Scheduled Interviews</div>
        <div class="d-flex align-items-center justify-content-end mr-2 w-50">
          <div
            class="position-relative w-50"
            v-if="
              scheduleInterview.length ||
              (!scheduleInterview.length && searchQuery != '')
            "
          >
            <span>
              <img
                class="gm-search-pos"
                src="../../assets/img/search-bar-icon.svg"
                alt
              />
            </span>
            <b-form-input
              class="gm-search-input"
              type="search"
              v-model.trim="searchQuery"
              debounce="500"
              placeholder="Search"
            ></b-form-input>
          </div>
          <div class="gm-grey-txt ml-4">Total Scheduled: {{ total }}</div>
        </div>
      </div>
      <b-overlay :show="showSpinner">
        <div class="gm-main-table">
          <div
            class="gm-table-head"
            v-if="
              scheduleInterview.length ||
              (!scheduleInterview.length && searchQuery != '')
            "
          >
            <div class="pl-4" :class="leadKey ? 'w-17' : 'w-20'">
              Candidate Name
              <template v-if="sortBy == 'candidate.name'">
                <img
                  v-if="sortByValue"
                  class="pointer"
                  @click="
                    (sortByValue = !sortByValue),
                      (sortBy = 'candidate.name'),
                      (sortOrder = 1),
                      (page = 0),
                      getAllScheduleInterviews()
                  "
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt=""
                />
                <img
                  v-if="!sortByValue"
                  class="pointer"
                  @click="
                    (sortByValue = !sortByValue),
                      (sortBy = 'candidate.name'),
                      (sortOrder = -1),
                      (page = 0),
                      getAllScheduleInterviews()
                  "
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt=""
                />
              </template>
              <img
                class="pointer"
                v-else
                @click="
                  (sortBy = 'candidate.name'),
                    (sortByValue = true),
                    (sortOrder = -1),
                    (showLoader = false),
                    (page = 0),
                    getAllScheduleInterviews()
                "
                src="../../assets/img/accessconnew/nosort.svg"
                alt=""
              />
            </div>
            <div :class="leadKey ? 'w-13' : 'w-20'">
              Job Name
              <template v-if="sortBy == 'jobName'">
                <img
                  v-if="sortByValue"
                  class="pointer"
                  @click="
                    (sortByValue = !sortByValue),
                      (sortBy = 'jobName'),
                      (sortOrder = 1),
                      (page = 0);

                    getAllScheduleInterviews();
                  "
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt=""
                />
                <img
                  v-if="!sortByValue"
                  class="pointer"
                  @click="
                    (sortByValue = !sortByValue),
                      (sortBy = 'jobName'),
                      (sortOrder = -1),
                      (page = 0);

                    getAllScheduleInterviews();
                  "
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt=""
                />
              </template>
              <img
                class="pointer"
                v-else
                @click="
                  (sortBy = 'jobName'),
                    (sortByValue = true),
                    (page = 0),
                    (sortOrder = -1);

                  getAllScheduleInterviews();
                "
                src="../../assets/img/accessconnew/nosort.svg"
                alt=""
              />
            </div>
            <div class="w-15" v-if="leadKey">Recruiter Name</div>
            <div class="w-15">Panelist Name</div>
            <div :class="leadKey ? 'w-17' : 'w-20'">
              Timings
              <template v-if="sortBy == 'startTime'">
                <img
                  v-if="sortByValue"
                  class="pointer"
                  @click="
                    (sortByValue = !sortByValue),
                      (sortBy = 'startTime'),
                      (sortOrder = 1),
                      (page = 0);

                    getAllScheduleInterviews();
                  "
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt=""
                />
                <img
                  v-if="!sortByValue"
                  class="pointer"
                  @click="
                    (sortByValue = !sortByValue),
                      (sortBy = 'startTime'),
                      (sortOrder = -1),
                      (page = 0);
                    getAllScheduleInterviews();
                  "
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt=""
                />
              </template>
              <img
                class="pointer"
                v-else
                @click="
                  (sortBy = 'startTime'),
                    (sortByValue = true),
                    (sortOrder = -1),
                    (page = 0);
                  getAllScheduleInterviews();
                "
                src="../../assets/img/accessconnew/nosort.svg"
                alt=""
              />
            </div>
            <div class="w-15">
              Scheduled on

              <template v-if="sortBy == 'scheduledOn'">
                <img
                  v-if="sortByValue"
                  class="pointer"
                  @click="
                    (sortByValue = !sortByValue),
                      (sortBy = 'scheduledOn'),
                      (sortOrder = 1),
                      (page = 0);

                    getAllScheduleInterviews();
                  "
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt=""
                />
                <img
                  v-if="!sortByValue"
                  class="pointer"
                  @click="
                    (sortByValue = !sortByValue),
                      (sortBy = 'scheduledOn'),
                      (sortOrder = -1),
                      (page = 0);

                    getAllScheduleInterviews();
                  "
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt=""
                />
              </template>
              <img
                class="pointer"
                v-else
                @click="
                  (sortBy = 'scheduledOn'),
                    (sortByValue = true),
                    (sortOrder = -1),
                    (page = 0);

                  getAllScheduleInterviews();
                "
                src="../../assets/img/accessconnew/nosort.svg"
                alt=""
              />
            </div>
            <div :class="leadKey ? 'w-8' : 'w-10'">Actions</div>
          </div>
          <div class="gm-table-body" @scroll="onScroll">
            <div
              v-if="
                !showSpinner &&
                scheduleInterview.length == 0 &&
                searchQuery != ''
              "
              class="
                d-flex
                flex-column
                align-items-center
                justify-content-center
                mt-4
              "
            >
              <div>
                <img
                  src="../../assets/New-imgs/landing-dashboard/no-data-dashboard.svg"
                  alt=""
                />
              </div>
              <div
                v-if="searchQuery != 'Loader' && searchQuery != ''"
                class="mt-3 text-center access-font-color"
              >
                No matching results for
                <span class="access-font-color-b text-center text-break">
                  "{{ searchQuery }}"
                </span>
              </div>
            </div>
            <div
              class="
                d-flex
                flex-column
                align-items-center
                justify-content-center
                h-100
              "
              v-else-if="
                !showSpinner &&
                scheduleInterview.length == 0 &&
                searchQuery == ''
              "
            >
              <div>
                <img
                  src="../../assets/New-imgs/landing-dashboard/no-scheduleInterview.svg"
                  alt=""
                />
              </div>
              <div class="text-center access-font-color">
                There is no interview scheduled with you.
              </div>
            </div>

            <div v-else>
              <div
                v-for="(int, index) in scheduleInterview"
                :key="index"
                class="gm-table-row"
              >
                <div
                  class="position-relative pl-4"
                  :class="leadKey ? 'w-17' : 'w-20'"
                >
                  <div class="gm-grid-line"></div>
                  <div class="text-truncate pr-1">{{ int.candidate.name }}</div>
                </div>
                <div
                  class="text-truncate pr-2"
                  :class="leadKey ? 'w-13' : 'w-20'"
                >
                  {{ int.jobName }}
                </div>
                <div class="w-15 text-truncate pr-2" v-if="leadKey">
                  {{ int.createdBy }}
                </div>
                <div
                  class="w-15 position-relative pl-1"
                  v-if="int.userIcons.length == 1"
                >
                  <div
                    v-for="(icon, iconIndex) in int.userIcons"
                    :key="iconIndex"
                  >
                    <div class="text-truncate">
                      {{ icon.name }}
                    </div>
                  </div>
                </div>
                <div class="w-15" v-else>
                  <div
                    class="d-flex align-items-center position-relative"
                    :style="
                      int.externalPanelist.length + int.panelist.length
                        ? 'width: 100px'
                        : int.externalPanelist.length + int.panelist.length ===
                          3
                        ? 'width: 70px;'
                        : int.externalPanelist.length + int.panelist.length ===
                          2
                        ? 'width: 45px;'
                        : int.externalPanelist.length + int.panelist.length ===
                          1
                        ? 'width: 20px;'
                        : ''
                    "
                  >
                    <div
                      v-for="(icon, iconIndex) in int.userIcons.slice(0, 4)"
                      :key="iconIndex"
                      class="roundDarkBlue"
                      :style="{ left: `${iconIndex * 25}px` }"
                      v-b-tooltip.hover="icon.name"
                    >
                      {{ icon.initials }}
                    </div>
                    <div
                      class="roundLightBlue"
                      v-if="int.userIcons.length > 4"
                      :style="{ left: '75px' }"
                      v-b-tooltip.hover="
                        getRemainingNamesTooltip(int.userIcons)
                      "
                    >
                      +{{ int.userIcons.length - 3 }}
                    </div>
                  </div>
                </div>

                <div class="pl-1" :class="leadKey ? 'w-17' : 'w-20'">
                  {{ formatDate(int.startTime) }}
                </div>
                <div class="w-15 pl-1">{{ int.scheduledOn }}</div>
                <div
                  class="d-flex align-items-center"
                  :class="leadKey ? 'w-8' : 'w-10'"
                >
                  <img
                    v-b-tooltip.hover="'View'"
                    v-if="
                      int.candidate.candidateID !==
                      selectedCandidate.candidate.candidateID
                    "
                    @click="viewCandidate(int)"
                    class="pointer"
                    src="../../assets/talentpool/blueEye.svg"
                    alt=""
                  />
                  <img
                    v-else-if="
                      int.candidate.candidateID ===
                      selectedCandidate.candidate.candidateID
                    "
                    src="../../assets/talentpool/notviewicon.svg"
                    alt=""
                  />

                  <img
                    v-b-tooltip.hover="'Join Meeting'"
                    @click="navigateToLink(int)"
                    class="ml-3 pointer"
                    src="../../assets/New-imgs/landing-dashboard/joinGroup.svg"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div
              style="margin: auto"
              class="d-flex justify-content-center mb-3"
              v-if="showLoader"
            >
              <b-spinner label="Loading..."></b-spinner>
            </div>
          </div>
        </div>
      </b-overlay>
    </div>

    <PreviewCandidateSidebar
      v-if="viewCandidateModal"
      :showModal="viewCandidateModal"
      :candidateID="selectedCandidate.candidate.candidateID"
      :customFieldsArray="customFieldsArray"
      :selectedCandidate="selectedCandidate.candidate"
      :showNote="false"
      :showActivate="false"
      @close-view-icon="closeViewIcon"
    />
  </div>
</template>

<script>
import {
  getDashboardInterviews,
  getCustomerFields,
} from "../../utils/apiFunctions.js";
import PreviewCandidateSidebar from "../../controllers/JD/modals/PreviewCandidateSidebar.vue";

import { mapGetters } from "vuex";

export default {
  name: "ScheduleInterview",
  props: {
    leadKey: Boolean,
  },
  components: {
    PreviewCandidateSidebar,
  },
  data() {
    return {
      showEye: false,
      showSpinner: false,
      sortByValue: false,
      showLoader: false,
      sortOrder: -1,
      total: null,
      pageEnd: null,
      viewCandidateModal: false,
      selectedCandidate: {
        candidate: {},
      },
      sortBy: "",
      page: 0,
      searchQuery: "",
      scheduleInterview: [],
      panelist: [],
      customFieldsArray: [],
    };
  },
  created() {
    this.showSpinner = true;

    this.getAllScheduleInterviews();
    this.getCustomField();
    if (this.$route.query.history) {
      this.viewCandidate({ candidate: this.storedData.candidate });
    }
  },
  watch: {
    searchQuery(newValue, oldValue) {
      if (newValue != oldValue) {
        if (newValue != "Loader") {
          this.showSpinner = true;
          this.page = 0;
          this.getAllScheduleInterviews();
        }
      }
    },
  },
  computed: {
    ...mapGetters("userVUEX", {
      projectUsers: "getProjectUsers",
    }),
    ...mapGetters("jobDescriptionVUEX", {
      storedData: "getSelectedCandidate",
    }),
  },
  methods: {
    getRemainingNamesTooltip(userIcons) {
      const remainingNames = userIcons.slice(3).map((icon) => icon.name);
      return remainingNames.join(", ");
    },
    formatDate(dateString) {
      const date = new Date(dateString);

      const timeOptions = {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      };

      const dayOptions = {
        weekday: "short",
      };

      const dateOptions = {
        year: "numeric",
        month: "short",
        day: "numeric",
      };

      const timeFormatter = new Intl.DateTimeFormat("en-US", timeOptions);
      const dayFormatter = new Intl.DateTimeFormat("en-US", dayOptions);
      const dateFormatter = new Intl.DateTimeFormat("en-US", dateOptions);

      const formattedTime = timeFormatter.format(date);
      const formattedDay = dayFormatter.format(date);
      const formattedDate = dateFormatter.format(date);

      return `${formattedTime} ${formattedDay}, ${formattedDate}`;
    },
    onScroll(e) {
      // Get the target element of the scroll event.
      const { target } = e;
      // Check if the user has reached the bottom of the scrollable area.
      if (
        Math.ceil(target.scrollTop) >=
        target.scrollHeight - target.offsetHeight
      ) {
        // Check if there is more data to load.
        if (
          this.checkbetween(this.pageEnd, 0, this.total) &&
          !this.showLoader
        ) {
          this.showLoader = true;
          this.page++;

          this.getAllScheduleInterviews();
        }
      }
    },
    checkbetween(x, min, max) {
      // Return `true` if `x` is between `min` and `max`, otherwise `false`.
      return x > min && x < max;
    },
    viewCandidate(int) {
      this.viewCandidateModal = true;
      this.selectedCandidate = int;
    },
    closeViewIcon() {
      this.viewCandidateModal = false;
      this.selectedCandidate = {
        candidate: {},
      };
    },
    async getCustomField() {
      try {
        let parentID = "5";
        let response = await getCustomerFields({ parentID });
        if (response.status == 200) {
          this.customFieldsArray = response.data.data.fields;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getAllScheduleInterviews() {
      let payload = {
        count: 10,
        page: this.page,
        searchQuery: this.searchQuery,
        sortBy: this.sortBy == "" ? "startTime" : this.sortBy,
        lead: this.leadKey,
        order: this.sortOrder,
        type: 1,
      };

      try {
        const res = await getDashboardInterviews(payload);
        if (res.status == 200) {
          this.showSpinner = false;
          if (this.page == 0) {
            this.scheduleInterview = res.data.data.data;
          } else {
            this.scheduleInterview = [
              ...this.scheduleInterview,
              ...res.data.data.data,
            ];
          }
          this.total = res.data.data.total;
          this.pageEnd = res.data.data.pageEnd;
          this.LoaderStatus = false;

          this.showLoader = false;

          for (let int of this.scheduleInterview) {
            int.userIcons = [];

            if (Array.isArray(int.externalPanelist)) {
              for (let panel of int.externalPanelist) {
                if (typeof panel === "string") {
                  const initials = panel.includes("@")
                    ? panel[0].toUpperCase()
                    : panel.slice(0, 1).toUpperCase();
                  int.userIcons.push({ initials, name: panel });
                }
              }
            }

            if (Array.isArray(int.panelist)) {
              for (let panel of int.panelist) {
                if (typeof panel.name === "string") {
                  const initials = panel.name.includes(" ")
                    ? panel.name
                        .split(" ")
                        .map((name) => name && name[0].toUpperCase())
                        .join("")
                    : panel.name.slice(0, 1).toUpperCase();
                  int.userIcons.push({ initials, name: panel.name });
                }
              }
            }
          }
        } else if (res.status == 500) {
          this.showSpinner = false;
        }
      } catch (error) {
        console.error("Error fetching schedule interviews:", error);
        this.showSpinner = false;
      }
    },

    getInitials(username) {
      return username.includes(" ")
        ? username
            .split(" ")
            .map((name) => name && name[0].toUpperCase())
            .join("")
        : username.slice(0, 2).toUpperCase();
    },
    navigateToLink(int) {
      if (int.meetingLink) {
        try {
          const url = new URL(int.meetingLink);
          window.open(url.href, "_blank");
        } catch (e) {
          window.open("http://" + int.meetingLink, "_blank");
        }
      }
    },
  },
};
</script>

<style lang="postcss" scoped></style>
